import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { colors, strCode } from "../../consts";
import { t } from "../../services";
import { deviceUtil } from "../../utils";

import {
  FlexContainers,
  IconButton,
  SVG,
  WhiteContainer,
  WrapperContainer
} from "../../components";
import { DahsboardTitle, DashboardTemplateWrapper } from "./styled";

const DashboardTemplate = ({
  id,
  title,
  isLoading,
  onShowDetails,
  onUpdateChartData = () => { },
  onDownloadCSV,
  children,
  mt,
  Component
}) => {
  const device = useSelector((store) => store.dashboardFilters.device);
  const [duoDevice, setDuoDevice] = useState(null);

  useEffect(() => {
    if (device?.id !== 0 && device?.value) {
      const deviceGroup = deviceUtil.getDeviceGroupByName(device.value);

      let duo = null;

      if (deviceGroup === "duoDevices") {
        const deviceTypes = deviceUtil.getDeviceTypesByName(device.value);

        if (deviceTypes?.length === 3) {
          duo = deviceTypes;
        }
      }

      setDuoDevice(duo);
    } else {
      setDuoDevice(null);
    }
  }, [device]);

  const dropdownRef = useRef(null);

  return (
    <DashboardTemplateWrapper Container={WhiteContainer} width="100%" height="100%">
      <WrapperContainer
        Container={FlexContainers.FlexRowBetween}
        width={"100%"}
        minHeight={32}
        gap={16}
        wrap={Component ? "wrap" : "nowrap"}
        innerRef={dropdownRef}>
        <DahsboardTitle>{t(title)}</DahsboardTitle>

        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={16}>
          {Component && !isLoading &&
            <Component id={id} onUpdateChartData={onUpdateChartData} />
          }

          {onDownloadCSV && !isLoading && (
            <IconButton onClick={onDownloadCSV} tooltipLabel={t(strCode.DOWNLOAD_DOT_CSV)}>
              <SVG.DownloadIcon />
            </IconButton>
          )}

          {onShowDetails && !isLoading && (
            <IconButton onClick={onShowDetails}>
              <SVG.ArrowRightIcon color={colors.RAISIN_50} />
            </IconButton>
          )}
        </WrapperContainer>
      </WrapperContainer>

      <WrapperContainer width={"100%"} mt={duoDevice && mt ? mt : 16}>
        {children}
      </WrapperContainer>
    </DashboardTemplateWrapper>
  );
};

DashboardTemplate.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  extendedDeviceNames: PropTypes.bool,
  onShowDetails: PropTypes.func,
  onUpdateChartData: PropTypes.func,
  onDownloadCSV: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  mt: PropTypes.number,
  Component: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
};

export default DashboardTemplate;
